/* eslint-disable */
import createIcon from '../createIcon';

const IconLoading3QuartersOutlined = createIcon({
  name: 'icon-loading-3-quarters-outlined',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M521.495891,64.098806 L512,64 C264.576432,64 64,264.576432 64,512 C64,532.50382 80.6216303,549.12545 101.12545,549.12545 C121.62927,549.12545 138.250901,532.50382 138.250901,512 C138.250901,305.584072 305.584072,138.250901 512,138.250901 L532.501673,138.800448 C730.114332,149.381859 885.749099,313.245228 885.749099,512 C885.749099,718.415928 718.415928,885.749099 512,885.749099 C491.49618,885.749099 474.87455,902.37073 474.87455,922.87455 C474.87455,943.37837 491.49618,960 512,960 C759.423568,960 960,759.423568 960,512 C960,268.228705 765.022994,69.1707289 521.495891,64.098806 Z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconLoading3QuartersOutlined;
